$(function () {
	$('.aside-menu').each(function () {
		var scrollArea = $('.aside-menu');
		var activeItem = $('.aside-menu__link.is-active');
		scrollArea.scrollLeft(activeItem.offset().left - scrollArea.offset().left + scrollArea.scrollLeft() - 30);
	});
});
